import styled from 'styled-components';

export const MainStyled = styled.main`
  display: grid;
  grid-template-columns: max-content auto;
  height: 100vh;
`;
